<template>
    <div>
        <transition-group name="bounce" class="d-flex flex-column gap-2">
            <OrderToProcess v-for="order in ordersToShow"
                            :key="order.integration_order_id"
                            :order="order"
                            :store="store"
            />
        </transition-group>
        <transition-group name="slide-fade">
            <Alert v-if="ordersToShow.length === 0 && pendingOrders.length > ordersToShow.length"
                   key="hidden_orders"
                   title="Invisible pending orders"
                   type="light-warning"
            >
                <template v-slot:icon>
                    <i class="fas fa-exclamation-triangle"/>
                </template>
                Your selection of order types hides pending orders.
            </Alert>
            <Alert v-if="pendingOrders.length === 0"
                   key="no_pending_orders"
                   :title="__('orders.no_open_orders')"
                   type="light-info"
            >
                <template v-slot:icon>
                    <i class="fas fa-check-circle"/>
                </template>
                <p>{{ __('orders.no_open_orders_text') }}</p>
                <div>
                    <button class="btn btn-sm btn-outline-info" @click="$emit('gotoDone')">
                        <i class="fas fa-list"/>
                        {{ __('orders.all') }}
                    </button>
                </div>
            </Alert>
        </transition-group>
    </div>
</template>

<script>
import OrderTypeIcon from './OrderTypeIcon';
import IntegrationIcon from '@components/Integrations/IntegrationIcon';
import OrderDeadlineCountdown from './OrderDeadlineCountdown';
import Center from '@components/Layout/Center.vue';
import DateTime from '@components/DateTime.vue';
import OrderTypeBadge from './OrderTypeBadge.vue';
import CheckButton from '@components/CheckButton.vue';
import OrderToProcess from './OrderToProcess.vue';
import {Portal} from 'portal-vue';
import Alert from "@components/Alert.vue";

export default {
    components: {
        Alert,
        OrderToProcess,
        CheckButton,
        OrderTypeBadge,
        OrderTypeIcon,
        IntegrationIcon,
        OrderDeadlineCountdown,
        Center,
        DateTime,
        Portal,
    },

    props: {
        pendingOrders: Array,
        visibleOrderTypes: Object,
        store: Object,
    },

    computed: {
        ordersToShow() {
            let orders = [];

            for (let order of this.pendingOrders) {
                if (this.visibleOrderTypes[order.type]) {
                    orders.push(order);
                }
            }

            return orders;
        },
    },
};
</script>

<style>
.bounce-enter-active {
    animation: bounce-in 0.35s;
}

.bounce-leave-active {
    transition: all 0.15s ease-out;
}

.bounce-leave-to {
    transform: translateY(10px);
    opacity: 0;
}

@keyframes bounce-in {
    0% {
        transform: scale(0.5);
    }
    40% {
        transform: scale(1.02);
    }
    100% {
        transform: scale(1);
    }
}
</style>
